import React from 'react'
import "./StudioPolicies.css"

const StudioPolicies = () => {
  return (
    <div className='policy-block'>
      <div className="studio-header">
        <p className="studio-title">Studio Policies</p>
        <p className="studio-intro">
          Studio Policies are set in place to ensure a smooth, safe, and
          efficient environment for both students and staff — promoting
          consistency, professionalism, and respect for everyone's time and
          space. Please read through our policies to help us maintain a positive
          and organized experience, and to ensure that all expectations are
          clear before reserving a class spot.
        </p>
      </div>

      <div className='line-container'>
        <div className='line'></div>
      </div>

      <div className="studio-policies">
        <p className="studio-subtitle">
          Art with Larisse Studio Policies - January 2025
        </p>
        <div className="studio-policy">
          <p className="studio-policy-title">Reserving your class spot:</p>
          <ul>
            <li>
              In order to reserve a spot in class you will need to pay at least
              one class a week for the whole month (or rest of the month if you
              started mid-month)
            </li>
            <li>
              Tuition varies month to month, depending on how many weeks there
              are for the day of the week you attend.
            </li>
            <li>
              To stay enrolled for future months, simply pay tuition via our
              website before the 1st of the next month and your same day and
              time will be saved for you.
            </li>
            <li>
              New students will start their enrollment by paying in person at
              the studio for tuition and supplies.
            </li>
            <li>
              We only accept credit card payments. Sorry, no cash or checks.
            </li>
          </ul>
          <p className="studio-policy-title">
            Paying tuition and avoiding a late fee:
          </p>
          <ul>
            <li>
              To avoid a late fee, tuition needs to be paid before the 1st of
              the month.
            </li>
            <ul>
              <li>
                A $20 late fee will automatically be included in the price of
                tuition starting at midnight on the 1st of the month.
              </li>
              <li>
                To receive reminders, we collect emails and send out a reminder
                at the end of each month to pay for the following month. We also
                recommend putting a reminder on your phone.
              </li>
            </ul>
          </ul>
          <p className="studio-policy-title">Class cancellation policies:</p>
          <ul>
            <li>
              If you need to cancel your class for any reason, you need to call
              or text the studio you attend no later than 12:00 noon on the day
              of your class.
            </li>
            <ul>
              <li>
                If you attend a morning class, you need to call or text the
                night before by 6pm.
              </li>
            </ul>
            <li>
              If you miss a class and do not notify the studio by the times
              mentioned above, you lose that class. We refer to this as a
              no-show.
            </li>
            <li>
              If you cancel a class by notifying us by the times mentioned
              above, you get what we call a makeup class.
            </li>
            <li>
              If your student is showing signs of sickness, call or text our
              studio immediately to let us know that they will be missing class.
              Please do not bring sick students to class. We will set up another
              day and time to have them make up.
            </li>
          </ul>
          <p className="studio-policy-title">Makeup class policies:</p>
          <ul>
            <li>
              Makeup classes can only be used in addition to your regularly
              scheduled class during months when tuition is paid and a student
              is enrolled.
            </li>
            <li>Makeups cannot be used when tuition has not been paid.</li>
            <li>
              You cannot apply makeup classes towards tuition in future months.
            </li>
            <li>
              Scheduling makeup classes:
              <ul>
                <li>
                  Makeup classes cannot be scheduled any earlier than Saturday
                  the week before.
                </li>
                <li>
                  You can reach out to us as early as Saturday to schedule
                  makeup classes for the following week.
                </li>
                <li>
                  Makeup classes will be scheduled based on class availability,
                  there are no guarantee that the class time you request will be
                  available for a makeup class.
                </li>
              </ul>
            </li>
            <li>
              Makeup classes apply to the same cancellation policies. If you
              miss/no-show to your scheduled makeup class, you lose that makeup
              class.
            </li>
          </ul>
          <p className="studio-policy-title">Class schedule change policy:</p>
          <ul>
            <li>
              If you need to make changes to your class day and time that you
              attend, please call the studio you attend and leave a message.
              This is the only way to establish room in another day and time.
            </li>
            <li>
              It would be greatly appreciated for you to notify us if you plan
              to discontinue classes prior to the beginning of the month.
            </li>
            <li>
              Changing schedules after the month started, may result in unused
              credits. These credits need to be used within the month purchased.
            </li>
          </ul>
          <p className="studio-policy-title">Student drop off:</p>
          <ul>
            <li>
              We welcome students as early as 5 minutes before the start of
              class, please do not drop off your student earlier than that.
            </li>
            <li>
              Parents are asked to wait outside the studio during class to keep
              distractions to a minimum.
            </li>
          </ul>
          <p className="studio-policy-title">Student pick up:</p>
          <ul>
            <li>
              Class is 1 hour long. At the end of the hour students will clean
              up and this can take up to 15 minutes to complete. Please be ready
              to pick up your student 1 hour after you drop them off and know
              that it could be a few minutes before they have cleaned up and are
              ready to leave.
            </li>
          </ul>
          <p className="studio-policy-title">Refer a friend policy:</p>
          <ul>
            <li>
              You can refer a new student to us and earn class credits that you
              can apply towards tuition.
            </li>
            <li>
              If the student you refer signs up and pays for 4 classes, you earn
              1 art class credit that you can apply towards your future monthly
              tuition.
            </li>
            <li>You cannot earn referrals for siblings.</li>
            <li>
              Out of town guests are welcome to join us for a paid class if
              there is availability, but the free introductory offer class only
              applies to residents of San Diego.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default StudioPolicies